export const loyaltyQueryKey = ['loyalty'] as const;
export const referralQueryKey = ['referral'] as const;
